import type { Transaction } from "@rocicorp/zero";
import { type Schema, zql } from "./generatedDrizzleSchema";
import { escapeLikePattern } from "./likePattern";

type Tx = Pick<Transaction<Schema>, "run">;

// Email lookup is an exact, case-insensitive match: ILIKE provides the
// case-insensitivity, escaping keeps `_`/`%` in the address literal. Email is
// only unique per tenant, so the lookup always carries the tenant.
export async function findUserByEmail(tx: Tx, tenantId: string, email: string) {
  const [user] = await tx.run(
    zql.user
      .where("tenantId", tenantId)
      .where("email", "ILIKE", escapeLikePattern(email))
  );
  return user ?? null;
}
